import { useHistory, useLocation } from 'react-router-dom';

// 地区
export const POP_REGION_KEY = 'shop_region';
// market和channel用于投放，不起实际作用
export const POP_MARKET_KEY = 'market';
export const POP_CHANNEL_KEY = 'channel';

// 默认地区
export const DEFAULT_POP_REGION = 'us';

export const POP_MARKET_LIST = [
  {
    market_region: 'us',
    market_name: 'pop_onboarding_marketpage_choice_us',
    shop_regions: ['us'],
  },
  {
    market_region: 'sea',
    market_name: 'markets_sea_market',
    shop_regions: ['th', 'my', 'vn', 'ph', 'sg'],
  },
  {
    market_region: 'eu',
    market_name: 'seller_onboarding_settle01_text_eu',
    shop_regions: ['de', 'es', 'fr', 'it', 'ie'],
  },
  {
    market_region: 'uk',
    market_name: 'pop_onboarding_marketpage_choice_uk',
    shop_regions: ['gb'],
  },
  {
    market_region: 'jp',
    market_name: 'pop_onboarding_marketpage_choice_jp',
    shop_regions: ['jp'],
  },
];

export const POP_REGION_LIST = POP_MARKET_LIST.reduce((prev, cur) => {
  return prev.concat(cur.shop_regions);
}, [] as string[]);

export const getPopRegion = () => {
  return (
    new URLSearchParams(location.search).get(POP_REGION_KEY) ||
    DEFAULT_POP_REGION
  );
};

export const getPopRegionByShopRegion = (shop_region: string) => {
  return (
    POP_MARKET_LIST.find(market => market.shop_regions.includes(shop_region))
      ?.market_region || ''
  );
};

export const getPopMarket = () => {
  return new URLSearchParams(location.search).get(POP_MARKET_KEY);
};

export const isPopMarketValid = (market?: string) =>
  POP_MARKET_LIST.some(item => item.market_region === market);

export const getPopReportQuery = (isQuery?: boolean): object => {
  const params = new URLSearchParams(location.search);
  const market = params.get(POP_MARKET_KEY);
  const channel = params.get(POP_CHANNEL_KEY);

  if (isQuery) {
    return ((market ? `${POP_MARKET_KEY}=${market}` : '') +
      (channel ? `&${POP_CHANNEL_KEY}=${channel}` : '')) as unknown as object;
  }

  return Object.assign(
    {},
    market ? { shop_region: market } : {},
    channel ? { channel } : {},
  );
};

export const usePopQuery = () => {
  const location = useLocation();
  const history = useHistory();

  const setRegionQuery = (region: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(POP_REGION_KEY, region);

    history.replace({ search: searchParams.toString() });
  };

  return {
    region: new URLSearchParams(location.search).get(POP_REGION_KEY),
    setRegionQuery,
  };
};
